<template>
    <div class="col-12 col-sm-3">
        <div class="abonement mt-lg-5 mt-0 mb-lg-0 mb-4">
            <div class="all-course" v-if="lastItem">полный курс</div>
            <div :class="[`month-n-${number}`, { 'month-6': !lastItem } , { 'month-12' : lastItem } ]">
                {{ subscription.description }}
            </div>
            <div class="price">{{ subscription.price | formatPrice }} <span class="rubls">{{ $t('cur') }}</span></div>
            <div v-if="subscription.pricebefore" class="econom">
                {{ subscription.pricebefore | formatPrice }} <span>{{ $t('cur') }}</span>
            </div>
            <div v-else class="econom"></div>
            <a href="javascript:void(0);"
               @click="order"
               :data-id="subscription.idsubscription"
               data-model="StudyProductSubscription"
               :data-price="subscription.price"
               data-action="order"
               :data-label="$t('sign_up')">{{ $t('sign_up') }}</a>
        </div>
    </div>
</template>

<script>
    import numeral from 'numeral';

    export default {
        name: "StudyProductSubscriptionItem",
        props: {
            title: String,
            subscription: {
                type: Object,
            },
            number: {
                type: [Number, String],
            },
            lastItem: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            order() {
                this.$emit('order', this.subscription)
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        },
        filters: {
            formatPrice: function (value) {
                return numeral(value).format("0,0.00").replace(/\.0+$/,'').replace(/,/g, '\u00A0')
            }
        }
    }
</script>

<style scoped>
    .abonement {
        max-width: 254px;
        min-height: 233px;
        border: 1px solid #d9e0e4;
        background: #fff;
        text-align: center;
        margin-top: 50px;
        border-radius: 10px;
        box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
        margin-left: auto;
        margin-right: auto;
    }

    .month-1, .month-3, .month-6, .month-12 {
        font-size: 22px;
        text-align: center;
        font-family: "Manrope Bold Alt";
        margin-bottom: 15px;
    }

    .month-1 {
        background: url(~@/assets/hometeacher/images/month-1.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-3 {
        background: url(~@/assets/hometeacher/images/month-3.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-6 {
        background: url(~@/assets/hometeacher/images/month-6.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-12 {
        background: url(~@/assets/hometeacher/images/month-12.png) no-repeat center;
        margin-top: 4px;
        color: #fff;
    }

    .price {
        font-family: "Manrope Bold";
        font-size: 30px;
        color: #72717d;
    }

    .rubls {
        font-size: 18px;
    }

    .econom {
        font-size: 15px;
        color: #231c37;
        margin-bottom: 17px;
        margin-top: -6px;
        text-shadow: 0px 0px 0px rgb(0 0 0);
        font-weight: bold;
        text-decoration: line-through;
    }

    .all-course {
        color: #ed1c24;
        font-family: "Manrope Black";
        font-size: 18px;
    }

    .abonement a {
        border-radius: 35px;
        max-width: 230px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 20px;
        color: #fff;
        padding: 14px 35px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
    }

    .abonement a:hover {
        background: #49d92c;
    }
</style>
